// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35hu0","questions":"styles_questions__v0665","footer":"styles_footer__2CO-s"};